import { FC, useCallback } from 'react';
import { NextTable } from '@shared/modules/next-table/containers';
import { useBackgroundNavigate } from '@shared/hooks';
import { CashRegistersTableContext } from '../context';
import { useCashRegistersTableColumns } from '../hooks';

export const CashRegistersTable: FC = () => {
  const columns = useCashRegistersTableColumns();
  const navigate = useBackgroundNavigate();

  const getRowProps = useCallback(
    (id: any) => ({
      onDoubleClick: () => navigate('/cash-flow/transactions', { state: { cashFlowTransactionsTable: { mergeState: { filters: [{ id: 'cashbox_id', value: String(id) }] } } } }),
    }),
    [navigate],
  );

  return <NextTable context={CashRegistersTableContext} columns={columns} getRowProps={getRowProps} />;
};
